import { combineReducers } from "redux";

import AepsReducer from "./Aeps";
import dashboardReducer from "./dashboard";
import DmtReducer from "./dmt";
import PayrentReducer from "./payrent";
import RechargeReducer from "./Recharge";
import reports from "./reports";
import ThemeReducer from "./ThemeReducer";
import userReducer from "./user";
import YpayReducer from "./Ypay";
import DmtV2Reducer from "./dmtv2";

const rootReducer = combineReducers({
  ThemeReducer,
  userReducer,
  dashboardReducer,
  reports,
  DmtReducer,
  AepsReducer,
  RechargeReducer,
  PayrentReducer,
  YpayReducer,
  DmtV2Reducer
});

export default rootReducer;
